<template>
  <!-- 课程悬浮 -->
  <div class="course-suspension-container" @click="openCourseDetail">
    <!-- 课程封面 -->
    <img class="course-cover" :src="courseInfo.courseScheduleImg" />
    <div class="course-info-box">
      <div class="info-top">
        <!-- 课程类型 -->
        <img class="course-type" :src="Number(courseInfo.classType) === 0 ? require('../../common/img/live_type.png') : require('../../common/img/record_type.png')" alt="">
        <!-- 课程名称 -->
        <div class="course-name">{{ courseInfo.courseScheduleName }}</div>
        <!-- 关闭按钮 -->
        <van-icon name="cross" class="tips-close" @click="closeCourseTips" v-if="showSendBtn" />
      </div>
      <div class="info-bottom">
        <!-- 老师名称 -->
        <div class="teacher-name">{{ courseInfo.teacherName }}</div>
        <!-- 课程价格 -->
        <div class="course-price">¥<span class="num">{{ courseInfo.courseSellPrice }}</span></div>
        <div class="send-btn" v-if="showSendBtn" @click="clickSend">发给客服</div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'webpack-merge'
export default {
  // props: ['showSendBtn', 'courseInfo'],
  props: {
    showSendBtn: {
      type: Boolean,
      default: false
    },
    courseInfo: {
      default: () => {}
    }
  },
  methods: {
    openCourseDetail () {
      let domain = `https://chindle.keyclass.cn/web/course/detail/${this.courseInfo.courseScheduleId}/${this.courseInfo.sellCourseScheduleId}`
      if (location.host.includes('test')) {
        // 测试环境
        domain = `https://uat.keyclass.cn/web/course/detail/${this.courseInfo.courseScheduleId}/${this.courseInfo.sellCourseScheduleId}`
      }
      window.open(domain)
    }
  }
}
</script>

<style lang="less" scoped>
.course-suspension-container{
  display: flex;
  padding: 10px 16px 10px 10px;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #eee;
  // width: 70%;
  cursor: pointer;
  &:hover{
    box-shadow: 0px 10px 10px 0px rgba(235, 235, 235, 1);
  }
  .course-cover{
    // width: 16vw;
    // height: 16vw;
    width: 100px;
    height: 100px;
    border-radius: 8px;
  }
  .course-info-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 0;
    margin-left: 10px;
    .info-top{
      display: flex;
      align-items: center;
      .course-type{
        height: 16px;
      }
      .course-name{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 20px 0 6px;
      }
    }
    .info-bottom{
      position: relative;
      .teacher-name{
        color: #666;
        font-size: 12px;
        margin-bottom: 9px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .course-price{
        color: #FF6D3E;
        font-size: 12px;
        font-weight: 500;
        .num{
          font-weight: 400;
          font-size: 16px;
        }
      }
      .send-btn{
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background: linear-gradient( 99deg, #FFAF3E 0%, #FF4242 100%);
        color: #fff;
        width: 80px;
        height: 26px;
        border-radius: 13px;
      }
    }
  }
}
// // 课程悬浮动画效果
// @keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-moz-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-webkit-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
// @-o-keyframes courseMove
// {
//   from {
//     transform: translateY(60%);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(-100%);
//     opacity: 1;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/Public/CourseSuspension.vue